const STORAGE_KEY = 'customerPromoDeviceId';

function createUuidV4(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const rand = (Math.random() * 16) | 0;
    const value = char === 'x' ? rand : (rand & 0x3) | 0x8;
    return value.toString(16);
  });
}

/**
 * Persist a stable UUID v4 for `X-Device-Id` on promo apply/remove (plan §3.12).
 */
export function getOrCreateCustomerPromoDeviceId(): string {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return createUuidV4();
  }
  try {
    const existing = window.localStorage.getItem(STORAGE_KEY)?.trim();
    if (existing && existing.length > 0) {
      return existing;
    }
    const created = createUuidV4();
    window.localStorage.setItem(STORAGE_KEY, created);
    return created;
  } catch {
    return createUuidV4();
  }
}
